﻿window.nodecapcode = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";

    function removeSelectedCapcodes() {

        var selectedIds = [];

        var listBox = $("#CapcodesSelected").data("kendoListBox");
        var allItems = listBox.items();
        var selectedItems = listBox.select();

        if (selectedItems.length > 0) {

            for (var i = 0; i < selectedItems.length; i++) {
                var index = allItems.index(selectedItems[i]);
                var item = listBox.dataSource.view()[index];
                selectedIds[i] = parseInt(item.Value);
            }
        }

        var list = selectedIds.slice();

        $.ajax({
            type: "POST",
            url: appsettings.getUrl("NodeCapcode/RemoveCapCodes"),
            data: {
                list: kendo.stringify(list)
            },
            dataType: 'json',
            success: function (responseData) {

                // refresh listbox
                var lb = $("#CapcodesSelected").data("kendoListBox");
                lb.dataSource.read();

                if (responseData != undefined && responseData != null) {
                    if (responseData.Succesfully) {
                        var btnDelete = document.getElementById("delete-button");
                        btnDelete.setAttribute("disabled", "disabled");
                    }
                    else {
                        main.makeResultMessage(responseData);
                    }                    
                }
            }
        });
    }


    return {

        initialize: function (label_yes, label_no, label_delete) {
            LABEL_YES = label_yes;
            LABEL_NO = label_no;
            LABEL_DELETE = label_delete;
        },

        deleteButtonClicked: function () {
            main.openActionsDialog(' ', LABEL_DELETE,
                [{ text: LABEL_YES, action: function () { removeSelectedCapcodes(); main.closePopup(); } },
                    { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
        },

        addButtonClicked: function () {            
            main.makeResultMessage();       // clear

            var tb = $("#capcode").data("kendoNumericTextBox");

            var capcode = tb.value();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl("NodeCapcode/AddCapCode"),
                data: {
                    capcode: capcode
                },
                dataType: 'json',
                success: function (responseData) {

                    // refresh listbox
                    var lb = $("#CapcodesSelected").data("kendoListBox");
                    lb.dataSource.read();

                    if (responseData != undefined && responseData != null) {
                        if (responseData.Succesfully) {
                            $("#capcode").data("kendoNumericTextBox").value(null);      // clear

                            var btnAdd = document.getElementById("add-button");
                            btnAdd.setAttribute("disabled", "disabled");
                        }
                        else {
                            main.makeResultMessage(responseData);
                        }                        
                    }

                }
            });
        },

        OnNumTextBoxChanged: function () {
            main.makeResultMessage();       // clear
            
            var btnAdd = document.getElementById("add-button");
            btnAdd.removeAttribute("disabled");
        },

        OnListBoxSelect: function () {
            var btnDelete = document.getElementById("delete-button");
            btnDelete.removeAttribute("disabled");
        }

    }

}();